export const BEGIN_DISPLAY_FEEDBACK_OVERLAY = "BEGIN_DISPLAY_FEEDBACK_OVERLAY";
export const SET_ACTIVE_FEEDBACK_PANE = "SET_ACTIVE_FEEDBACK_PANE";
export const END_DISPLAY_FEEDBACK_PANES = "END_DISPLAY_FEEDBACK_PANES";
export const SET_CAPTURED_FEEDBACK = "SET_CAPTURED_FEEDBACK";
export const SEND_CAPTURED_FEEDBACK = "SEND_CAPTURED_FEEDBACK";
export const CLEAR_CAPTURED_FEEDBACK = "CLEAR_CAPTURED_FEEDBACK";
export const SET_ACTIVE_FEEDBACK_PANE_FOCUS = "SET_ACTIVE_FEEDBACK_PANE_FOCUS";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/actions/actionTypes.js